import axios from "axios";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import GenericCrudPanel from "../../components/common/crud/GenericCrudPanel";

const HR_BASE = `${process.env.REACT_APP_BACKEND_API_URL}/hr`;

const ACTIVE_STATUS_OPTIONS = [
  { value: "ACTIVE", label: "Active" },
  { value: "INACTIVE", label: "Inactive" },
];

const MODULE = {
  key: "designation",
  title: "Designations",
  endpoint: "/designation/",
  fields: [
    { name: "title", label: "Title", required: true },
    { name: "department", label: "Department", type: "select", optionsKey: "departmentOptions" },
    { name: "status", label: "Status", required: true, type: "select", optionsKey: "activeStatusOptions" },
  ],
  columns: [
    { name: "Title", selector: (row) => row.title || "-", sortable: true },
    { name: "Department", selector: (row) => row.department_data?.name || "-", sortable: true },
    { name: "Status", selector: (row) => row.status || "-", sortable: true },
  ],
  initialForm: { title: "", department: "", status: "ACTIVE" },
};

async function loadOptions() {
  const departments = await axios.get(`${HR_BASE}/department/`);
  return {
    departmentOptions: (departments.data || []).map((item) => ({ value: item.id, label: item.name })),
    activeStatusOptions: ACTIVE_STATUS_OPTIONS,
  };
}

function DesignationMaster() {
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");

  const handleDataFromTopNavBar = (permissiondata) => {
    setDataFromTopNavBar(permissiondata);
  };

  return (
    <div className="page-content-bg">
      <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true} sendDataToParent={handleDataFromTopNavBar} />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="DesignationMaster"
        activeSubMenuLevel1=""
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"}>
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-sm-6 py-1">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                {menuDrawerShow ? <span><i className="fa fa-chevron-left mx-1"></i></span> : <span><i className="fa fa-chevron-right mx-1"></i></span>}
              </Button>
              <span className="page-header-text">Designation Master</span>
            </div>
          </div>
        </div>

        <div className="col-12 text-left" style={{ marginTop: -5, paddingLeft: 20, paddingRight: 30 }}>
          <GenericCrudPanel module={MODULE} baseUrl={HR_BASE} loadOptions={loadOptions} />
        </div>
      </div>

      <ToastContainer />
    </div>
  );
}

export default DesignationMaster;
